import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-white" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary text-body-1 font-weight-bold" }, "Enter your reset code", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-primary text-body-1 font-weight-bold" }, "Enter a new password", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoginError = _resolveComponent("LoginError")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_otp_input = _resolveComponent("v-otp-input")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_ActionButton = _resolveComponent("ActionButton")!

  return (_openBlock(), _createBlock(_component_v_row, {
    justify: "center",
    align: "center"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_col, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            "no-gutters": "",
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_LoginError, { error: _ctx.error }, null, 8, ["error"]),
                  (_ctx.info)
                    ? (_openBlock(), _createBlock(_component_v_alert, {
                        key: 0,
                        density: "compact",
                        class: "text-left",
                        type: "info",
                        color: "error"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.info), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { align: "center" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { class: "text-center" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, { dense: "" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, { cols: "12" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_otp_input, {
                    class: "otp",
                    length: "6",
                    modelValue: _ctx.code,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.code) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "text-center"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                class: "px-4"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.passwordValid,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.passwordValid) = $event)),
                    ref: "passwordForm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        placeholder: "New password",
                        "persistent-placeholder": "",
                        variant: "underlined",
                        "bg-color": "#ffffff",
                        "append-icon": _ctx.value['new'] ? 'mdi-eye' : 'mdi-eye-off',
                        "onClick:append": _cache[1] || (_cache[1] = () => (_ctx.value['new'] = !_ctx.value['new'])),
                        type: _ctx.value['new'] ? 'password' : 'text',
                        "onUpdate:modelValue": [
                          _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.repeatPasswordForm.validate())),
                          _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newPassword) = $event))
                        ],
                        modelValue: _ctx.newPassword,
                        rules: [
                    (v) => (v && v.length >= 6) || 'Password must be at least 6 characters long.',
                    (v) => (v && v.toUpperCase() !== v) || 'Password must contain a lowercase character.',
                    (v) => (v && v.toLowerCase() !== v) || 'Password must contain an uppercase character.',
                    (v) => (v && /\d/.test(v)) || 'Password must contain a number.',
                    (v) => (v && _ctx.symbols.test(v)) || 'Password must contain a special character.',
                ],
                        autocomplete: "off"
                      }, null, 8, ["append-icon", "type", "modelValue", "rules"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_v_form, {
                    modelValue: _ctx.repeatValid,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.repeatValid) = $event)),
                    ref: "repeatPasswordForm"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_text_field, {
                        placeholder: "Repeat new password",
                        "persistent-placeholder": "",
                        variant: "underlined",
                        "bg-color": "#ffffff",
                        "append-icon": _ctx.value['repeat'] ? 'mdi-eye' : 'mdi-eye-off',
                        "onClick:append": _cache[5] || (_cache[5] = () => (_ctx.value['repeat'] = !_ctx.value['repeat'])),
                        type: _ctx.value['repeat'] ? 'password' : 'text',
                        modelValue: _ctx.repeatedPassword,
                        "onUpdate:modelValue": [
                          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.repeatedPassword) = $event)),
                          _cache[7] || (_cache[7] = ($event: any) => (_ctx.$refs.repeatPasswordForm.validate()))
                        ],
                        rules: [
                    (v) => !_ctx.passwordValid || v === _ctx.newPassword || 'Passwords do not match.'
                ],
                        autocomplete: "off"
                      }, null, 8, ["append-icon", "type", "modelValue", "rules"])
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_row, {
            justify: "center",
            class: "mt-n4"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                class: "text-center"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    style: {"color":"#f2243f"},
                    onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.goToResend && _ctx.goToResend(...args)))
                  }, "Resend reset code?")
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, { class: "d-flex justify-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ActionButton, {
                    width: "95",
                    onClick: _ctx.confirmActivationCode,
                    text: "Confirm",
                    color: "primary",
                    loading: _ctx.loading,
                    disabled: _ctx.loading || !_ctx.passwordValid || !_ctx.repeatValid || !_ctx.newPassword || !_ctx.repeatedPassword
                  }, null, 8, ["onClick", "loading", "disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}